import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponentData, ConfirmDialogMessageData } from './confirm-dialog-data';
import { CommonModule } from '@angular/common';
import { PComponent } from '@design-system/layout/p/p.component';
import { BodyComponent } from '@design-system/typography/body/body.component';
import { H4Component } from '@design-system/typography/h4/h4.component';
import { ButtonComponent } from '@design-system/buttons/button/button.component';
import { DynamicModule } from 'ng-dynamic-component';
import { ContentBlockComponent } from '@design-system/layout/content-block/content-block.component';
/**
 * Standard inline replacement for javascript confirm().
 * A useful dialog in which to capture a binary response from the user.
 * See {@link OnScreenMessagingService#openConfirmationDialog} for usage
 */
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    PComponent,
    BodyComponent,
    H4Component,
    ButtonComponent,
    DynamicModule,
    ContentBlockComponent
  ]
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogMessageData | ConfirmDialogComponentData
  ) {}
  
  // Type assertion functions for template use
  asComponentData(data: any): ConfirmDialogComponentData {
    return data as ConfirmDialogComponentData;
  }
  
  asMessageData(data: any): ConfirmDialogMessageData {
    return data as ConfirmDialogMessageData;
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }
}
